/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Foot_FeedbackInputs */

const en_mk_foot_feedback = /** @type {(inputs: Mk_Foot_FeedbackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Feedback`)
};

const id_mk_foot_feedback = /** @type {(inputs: Mk_Foot_FeedbackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Masukan`)
};

/**
* | output |
* | --- |
* | "Feedback" |
*
* @param {Mk_Foot_FeedbackInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_foot_feedback = /** @type {((inputs?: Mk_Foot_FeedbackInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Foot_FeedbackInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_foot_feedback(inputs)
	return en_mk_foot_feedback(inputs)
});